import Vue from 'vue'
import Router from 'vue-router'
import VueCookie from 'vue-cookie'
// import sha256 from 'js-sha256'
import TimeTable from '../components/TimeTable'
import Login from '../components/basic/Login'
import vuescroll from 'vue-scroll'

Vue.use(Router)
Vue.use(VueCookie)
Vue.use(vuescroll)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'TimeTable',
      component: TimeTable,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/login/',
      name: 'Login',
      component: Login
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   const DIGESTKEY = process.env.DIGEST_KEY
//   if (to.matched.some(record => record.meta.requireAuth)) {
//     if (VueCookie.get('input_id') !== sha256.hmac(DIGESTKEY, process.env.BASIC_ID) ||
//       VueCookie.get('input_pass') !== sha256.hmac(DIGESTKEY, process.env.BASIC_PASS)) {
//       next({
//         path: '/login'
//       })
//     } else {
//       next()
//     }
//   } else {
//     next()
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js